var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.998,
    viewBox: "0 0 16 15.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search_FILL0_wght300_GRAD0_opsz40",
    d: "M141.911-813.559a5.556,5.556,0,0,1-4.083-1.672,5.528,5.528,0,0,1-1.672-4.061,5.529,5.529,0,0,1,1.672-4.061,5.533,5.533,0,0,1,4.065-1.672,5.532,5.532,0,0,1,4.064,1.672,5.53,5.53,0,0,1,1.671,4.061,5.614,5.614,0,0,1-.34,1.934,5.5,5.5,0,0,1-.958,1.671l5.65,5.625a.575.575,0,0,1,.175.423.572.572,0,0,1-.175.436.6.6,0,0,1-.434.177.569.569,0,0,1-.427-.18l-5.634-5.634a5.133,5.133,0,0,1-1.64.947A5.673,5.673,0,0,1,141.911-813.559Zm-.01-1.188a4.375,4.375,0,0,0,3.22-1.323,4.391,4.391,0,0,0,1.319-3.223,4.391,4.391,0,0,0-1.319-3.223,4.375,4.375,0,0,0-3.22-1.323,4.4,4.4,0,0,0-3.233,1.323,4.382,4.382,0,0,0-1.325,3.223,4.382,4.382,0,0,0,1.325,3.223A4.4,4.4,0,0,0,141.9-814.746Z",
    transform: "translate(-136.155 825.025)",
    fill: "#00bdd9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1195c36a463f5e0945d9332b696aca4a.svg";
export { ForwardRef as ReactComponent };